import React, {useEffect} from 'react';
import {Link} from 'react-router-dom';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import Drawer from '@material-ui/core/Drawer';
import List from '@material-ui/core/List';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import Divider from '@material-ui/core/Divider';
import AllNestedLink from './AllNestedLink';
import { connect } from 'react-redux';
import { NestedList, SimpleList } from './NestedList';

import accredhospilogo from '../assets/images/accredhospi-logo.png'

const useStyles = makeStyles((theme) =>({
	rootLinkList: {
		width: "100%",
    maxWidth: 400,
    backgroundColor: theme.palette.background.paper
	},
	fullList: {
		height: '100%',
    minWidth: 300,
  },
	titleContainer: {
		flexDirection: 'column',
		width: '100%',
		marginTop: '5%',
		marginBottom: '5%',
		alignItems: 'center',
		justifyContent: 'center',
	},
	title: {
		width: '60%',
		color: 'gray',
	},
	btn: {
      '& .MuiButton-label' :{
          textTransform :'none',
					fontWeight: 'bold',
					fontSize: '16px'
      }
  }
}));

const NavDrawer = ({referentiel, openDrawer, setOpenDrawer}) => {
  // state
	const classes = useStyles();

	// functions to work
  const toggleDrawer = (open) => (event) => {
    if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
      return;
    }               
    setOpenDrawer(open);
  };

	const ManuelMethod = () => {
		return (
			<>
				<SimpleList itemName='Le manuel d’accréditation hospitalière' linkLocation='/manuel' />
				<SimpleList itemName='Méthodologie d’évaluation' linkLocation='/methodologie' />
			</>
		)
	}

  const ListNavLink = () => (
    <div
      className={clsx(classes.fullList)}
      role="presentation"
      onKeyDown={toggleDrawer(false)}
    >
		<div  className={classes.titleContainer} >
			<div  className={classes.title} >
			<Grid container item direction='column' alignItems='center' justify='center' style={{width: '180px', height: '180px', marginLeft: '10%'}} >
				<img src={accredhospilogo} alt='Logo AccredHospi' style={{width: '175px', height: '139px'}} />
			</Grid>
				<Typography variant='h6' align='center' color='inherit'>
					Accredhospi-Bénin 
				</Typography>
			</div>
		</div>
			<Divider />
			 <List
      component="nav"
      aria-labelledby="nested-list-subheader"
      className={classes.rootLinkList}>
				{/* Acceuil */}
				<SimpleList itemName='Accueil' linkLocation='/' />

				{/* Infos generales */}
				<SimpleList itemName='Informations générales' linkLocation='/infos' />
				
				{/*all referentiel of domaine 1*/}
				<AllNestedLink NestedField={referentiel} />

				{/* Resultats */}
				<SimpleList itemName='Résultats' linkLocation='/resultats' />

				{/* fonctionnement */}
				<SimpleList itemName='Fonctionnement' linkLocation='/fonctionnement' />

				{/* A propos */}
				<SimpleList itemName='A propos' linkLocation='/apropos' />

				{/* Contact */}
				<SimpleList itemName='Nous contacter' linkLocation='/contact' />

				<Button href='https://www.accredhospi-benin.com/' className={classes.btn}>
					Accredhospi-Bénin
				</Button>
			
			</List>
    </div>
  );

  return (
    <div>
       <Drawer anchor='left' open={openDrawer} onClose={toggleDrawer(false)}>
        	<ListNavLink />
        </Drawer>
    </div>
  );
}

const mapStateToProps = (state) => {
	return {
		referentiel: state.setReferentielReducer.referentiel
	}
}

export default connect(mapStateToProps)(NavDrawer);